import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'mineral-ui/Button';

const propTypes = {
  children: PropTypes.string.isRequired,
  handleCapture: PropTypes.func.isRequired,
  selectedFile: PropTypes.objectOf({
    name: PropTypes.string,
  }),
  accept: PropTypes.string,
};

const defaultProps = {
  selectedFile: null,
  accept: 'image/*',
};

export default function FileInput(
  {
    handleCapture, selectedFile, accept, children,
  },
) {
  // Create a reference to the hidden file input element
  const hiddenFileInput = useRef(null);
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  return (
    <>
      <Button onClick={handleClick}>
        {children}
      </Button>
      {(selectedFile && selectedFile != null) ? (
        <p>
          <b>Selected File: </b>
          {selectedFile.name}
        </p>
      ) : null}
      <input
        accept={accept}
        type="file"
        ref={hiddenFileInput}
        onChange={handleCapture}
        style={{ display: 'none' }}
      />
    </>
  );
}

FileInput.propTypes = propTypes;
FileInput.defaultProps = defaultProps;
